document.addEventListener('DOMContentLoaded', function () {
    // make it as accordion for smaller screens
    if (window.innerWidth > 992) {
        document
            .querySelectorAll('.navbar .nav-item, .dropdown')
            .forEach(function (everyitem) {
                everyitem.addEventListener('mouseover', function (e) {
                    let el_link = this.querySelector('a[data-bs-toggle]');

                    if (el_link != null) {
                        let nextEl = el_link.nextElementSibling;
                        el_link.classList.add('show');
                        nextEl.classList.add('show');
                    }
                });
                everyitem.addEventListener('mouseleave', function (e) {
                    let el_link = this.querySelector('a[data-bs-toggle]');

                    if (el_link != null) {
                        let nextEl = el_link.nextElementSibling;
                        el_link.classList.remove('show');
                        nextEl.classList.remove('show');
                    }
                });
            });
    }
    // end if innerWidth
});
// DOMContentLoaded  end

const icons = document.querySelectorAll('.btnToggler');
const HeadTop = document.querySelector('.header__top');
const Body = document.querySelector('body');
const OffCanv = document.querySelector('#offcanvasNavbar');
icons.forEach((icon) => {
    icon.addEventListener('click', (event) => {
        icon.classList.toggle('open');
        HeadTop.classList.toggle('open');
    });
    if (!icon.classList.contains('open')) {
        OffCanv.addEventListener('click', (event) => {
            icon.classList.remove('open');
        });
    } else {
        OffCanv.addEventListener('click', (event) => {
            icon.classList.add('open');
        });
    }
});

const navLinks = document.querySelectorAll('.nav-link');

navLinks.forEach((link) => {
    if (link.getAttribute('href') === window.location.pathname) {
        link.classList.add('active');
    }
});

const stickyLinks = document.querySelectorAll('.sticky__link');

stickyLinks.forEach((sticky) => {
    if (sticky.getAttribute('href') === window.location.href) {
        sticky.classList.add('disabled');
        sticky.classList.remove('btn__secondary');
    }
    console.log(window.location.href);
});
